import { DocumentAttachment } from '../../types';
import { IAsynchronouslyLoadedValue } from './asynchronouslyLoadedValue';

export type ClaimListState = {
    currentPage: number;
    searchValueMap: ClaimSearchValueMap;
    sortColumn: string;
    sortDirection: ClaimTableSortDirection;
    dateRange: string[];
    startAt: number;
    currentRecordNumber: number;
    totalRecords: number | undefined;
    claimListData: IAsynchronouslyLoadedValue<ClaimMetadata[]>;
};

export type ClaimProcessingError = {
    errorCode: string;
    errorMessage: string;
    parameters: Object;
};

export enum CreditMemoStatus {
    COMPLETED = 'COMPLETED',
    PROCESSING = 'PROCESSING',
    NOT_PROCESSED = 'NOT_PROCESSED',
    NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export enum SearchableClaimFields {
    resellerClaimNumber = 'resellerClaimNumber',
    uploadedByUser = 'uploadedByUser', // createdByUser
    oracleTransactionNumber = 'oracleTransactionNumber', // creditMemoNumber
}

export type ClaimMetadata = {
    claimId?: string;
    resellerClaimNumber: string;
    createdByUser: string;
    submissionDate: number;
    resellerId: string;
    fileId: string;
    status: string;
    errorList: ClaimProcessingError[];
    creditMemoLink: string;
    creditMemoStatus: CreditMemoStatus;
    creditMemoNumber: string;
    fileName?: string;
    attachments?: DocumentAttachment[];
};

// the keys must match the ClaimmMetadata model from SCS as build the ES query using that
export type ClaimSearchValueMap = {
    resellerClaimNumber?: string[];
    oracleTransactionNumber?: string[]; // CM number
    uploadedByUser?: string[];
    creationStatus?: string[]; // claim status
    creditMemoStatus?: string[];
};

export const ALL_VALUES = 'all';

export type ClaimFilter = {
    searchValueMap?: ClaimSearchValueMap;
    dateRangeSearchMap?: {
        submissionDate: DateRange;
    };
};

export type DateRange = {
    fromDate: number;
    toDate: number;
};

export type ClaimSortAttribute = {
    key: string;
    value: string;
};

export type ClaimsListOutput = {
    claimsList: ClaimMetadata[];
    totalResults: number;
};

export enum ClaimTableSortDirection {
    ascending = 'ascending',
    descending = 'descending',
}
